import React from 'react';
import styled from 'styled-components';
import { FiMail, FiHeart } from 'react-icons/fi';
import { GiCoral, GiTropicalFish } from 'react-icons/gi';

const FooterContainer = styled.footer`
  background: ${props => props.theme.gradients.wave};
  color: white;
  padding: 60px 0 30px;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 3rem;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }
`;

const FooterSection = styled.div`
  h4 {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: white;

    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
      justify-content: center;
    }
  }

  p {
    opacity: 0.9;
    line-height: 1.6;
    margin-bottom: 0.5rem;
  }

  a {
    color: white;
    text-decoration: none;
    opacity: 0.9;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 1;
      text-decoration: underline;
    }
  }
`;

const FooterBottom = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    flex-direction: column;
    text-align: center;
  }
`;

const Copyright = styled.p`
  opacity: 0.8;
  font-size: 0.9rem;
`;

const MadeBy = styled.p`
  opacity: 0.8;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  a {
    color: white;
    text-decoration: none;
    font-weight: 600;
    transition: all 0.3s ease;

    &:hover {
      opacity: 1;
      text-decoration: underline;
    }
  }

  .heart {
    color: #ff6b6b;
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.1); }
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <h4>
            <GiCoral />
            Riffzauber
          </h4>
          <p>
            Private Abgabe von überschüssigen Meereslebewesen aus meinem Hobby-Aquarium 
            im Raum Zürich. Alle Tiere stammen aus nachhaltiger Zucht.
          </p>
        </FooterSection>

        <FooterSection>
          <h4>
            <GiTropicalFish />
            Angebot
          </h4>
          <p>Korallen verschiedener Schwierigkeitsgrade</p>
          <p>Meerwasserfische für jede Aquariengrösse</p>
          <p>Beratung für Aquarien-Einsteiger</p>
        </FooterSection>

        <FooterSection>
          <h4>
            <FiMail />
            Kontakt
          </h4>
          <p>Raum Zürich, Schweiz</p>
          <p>
            <a href="/kontakt">Kontaktformular</a>
          </p>
          <p>Abholung nach Vereinbarung</p>
        </FooterSection>
      </FooterContent>

      <FooterBottom>
        <Copyright>
          © {new Date().getFullYear()} Riffzauber. Alle Rechte vorbehalten.
        </Copyright>
        <MadeBy>
          Made with <FiHeart className="heart" /> by{' '}
          <a 
            href="https://www.alpinewebs.ch" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            alpinewebs.ch
          </a>
        </MadeBy>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;
